module.exports = __webpack_public_path__ + "static/media/30OIOS5.fe3de79f.jpg";